// Styles
import './about.less';

function About() {
    return (
        <div className="about-wrap">
            <div className="heading">
                <h2>Hi, I'm <span>Matthew Rungwe</span>. It's nice to meet you.</h2>
            </div>
            <div className="info">
                <p>
                    My journey as a Front-End Developer started off not too 
                    long ago. I was curious about the web and how it worked.
                    The curiosity grew into a passion and the  passion into 
                    a career.  
                </p>

                <p>
                    I have managed to grow my skills, secure a position as 
                    a freelancer, become a mentor and be a writer of web content.
                </p>

                <p>
                    I'm quietly confident, driven and always learning. I 
                    am constantly growing and giving back to my community  
                    one commit at a time.
                </p>
            </div>
        </div>
    );
}

export default About;